export const formatMedicationName = (name: string) => {
  if (name.length > 14) {
    return `${name.slice(0, 14)}...`;
  }

  return name;
}